/* GSG thumbnail-rail scroll buttons (2026-09-01). Lifecycle-aware, loaded
   ONCE: Concept replaces the gallery via destination.innerHTML on every
   valid variant change, which re-renders the buttons but never re-executes
   inline scripts - so this controller lives outside the swapped subtree.
   - Click handling is DELEGATED at the document level and resolves the rail
     through the button's aria-controls id, so freshly re-rendered buttons
     work with zero re-wiring.
   - Disabled/hidden sync needs per-rail listeners (scroll + ResizeObserver);
     scan() wires new rails and disconnects observers for rails whose nodes
     left the DOM. Re-scanned after Concept's variantChange pubsub and
     shopify:section:load.
   - Step distance = first thumb height + the rail's computed row-gap (no
     hardcoded gap). */
(function () {
  'use strict';
  if (window.__gsgThumbNav) return;
  window.__gsgThumbNav = true;

  var wired = []; /* [{ dots, ro }] */

  function controlsFor(dots) {
    var wrap = dots.closest('scroll-shadow') || dots.parentElement;
    return {
      up: wrap ? wrap.querySelector('.gsg-thumbs-step--up') : null,
      down: wrap ? wrap.querySelector('.gsg-thumbs-step--down') : null
    };
  }

  function stepSize(dots) {
    var first = dots.firstElementChild;
    if (!first) return dots.clientHeight * 0.6;
    var gap = parseFloat(getComputedStyle(dots).rowGap) || 0;
    return first.getBoundingClientRect().height + gap;
  }

  function sync(dots) {
    var c = controlsFor(dots);
    if (!c.up || !c.down) return;
    var max = dots.scrollHeight - dots.clientHeight;
    var scrollable = max > 1;
    c.up.hidden = !scrollable;
    c.down.hidden = !scrollable;
    c.up.disabled = dots.scrollTop <= 1;
    c.down.disabled = dots.scrollTop >= max - 1;
  }

  function wire(dots) {
    var onScroll = function () { sync(dots); };
    dots.addEventListener('scroll', onScroll, { passive: true });
    var ro = null;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(onScroll);
      ro.observe(dots);
    }
    wired.push({ dots: dots, ro: ro });
    sync(dots);
  }

  function scan() {
    /* release rails whose nodes were replaced out of the DOM */
    wired = wired.filter(function (w) {
      if (w.dots.isConnected) return true;
      if (w.ro) { try { w.ro.disconnect(); } catch (e) {} }
      return false;
    });
    var live = document.querySelectorAll('media-dots[id^="MediaDots-"]');
    for (var i = 0; i < live.length; i++) {
      var dots = live[i];
      var known = wired.some(function (w) { return w.dots === dots; });
      if (!known) wire(dots);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.gsg-thumbs-step');
    if (!btn || btn.disabled) return;
    var dots = document.getElementById(btn.getAttribute('aria-controls'));
    if (!dots) return;
    var dir = btn.classList.contains('gsg-thumbs-step--down') ? 1 : -1;
    dots.scrollBy({ top: dir * stepSize(dots), behavior: 'smooth' });
  });

  (function subscribe() {
    if (window.theme && window.theme.pubsub && window.theme.pubsub.subscribe) {
      var evt = (window.theme.pubsub.PUB_SUB_EVENTS && window.theme.pubsub.PUB_SUB_EVENTS.variantChange) || 'variantChange';
      window.theme.pubsub.subscribe(evt, function () { setTimeout(scan, 0); });
    } else {
      setTimeout(subscribe, 250);
    }
  })();

  document.addEventListener('shopify:section:load', function () { setTimeout(scan, 0); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
